module.exports = __webpack_public_path__ + "img/ts.cbedbf54.png";